import { ContactSelectors } from '@copilot/common/store/selectors/contact';
import { Skeleton } from 'antd';
import ContactDrawerTabbedContent from './contactDrawerTabbedContent';
import { spacingMD } from '@copilot/common/constant/commonStyles';
import { useSelector } from 'react-redux';
import { useProspectDrawerTracking } from '../tracking';
import { OrmState, SessionBoundModel } from 'redux-orm';
import { ContactConnection, ConversationThread } from '@copilot/common/store/models/redux';
import {
    ConnectionResponse,
    MemberLinkedInProfileResponse,
} from '@copilot/data/responses/interface';
import styles from './contactDrawerTabbedContent.module.less';
import { ContactDrawerTabs } from './constants';
import { AutomatedStep } from '@copilot/common/pages/inbox/ui/component/card/messageCard/types';
import { CommunicationStylesAnalysis } from '@copilot/common/types/communicationStyles';

type ContactDrawerTabbedContentSmartProps = {
    isMessagesLoading: boolean;
    contactId: string;
    contactConnection: SessionBoundModel<ContactConnection, {}> | null;
    isNewProspectDrawerEnabled: boolean;
    conversation: SessionBoundModel<ConversationThread, {}> | null;
    orgId: string;
    selectedConnection: ConnectionResponse | undefined;
    contactProfile: MemberLinkedInProfileResponse | undefined;
    tab: ContactDrawerTabs | undefined;
    isOwner: boolean;
    automatedSteps: AutomatedStep[] | undefined;
    onMessageSent: () => void;
    communicationStyles?: CommunicationStylesAnalysis;
};
/**
 * Panel containing the conversation info for the contact panel
 * @param param0
 * @returns
 */
export default function ContactDrawerTabbedContentSmart({
    isMessagesLoading,
    contactId,
    contactConnection,
    isNewProspectDrawerEnabled,
    conversation,
    orgId,
    selectedConnection,
    contactProfile,
    tab,
    isOwner,
    automatedSteps,
    onMessageSent,
    communicationStyles,
}: ContactDrawerTabbedContentSmartProps) {
    const contact = useSelector((state: { entities: OrmState<any> }) =>
        ContactSelectors.getContact(state, contactId)
    );
    const handleTracking = useProspectDrawerTracking('Prospect Drawer');

    return (
        <div
            className={[
                styles.panelWrapper,
                isNewProspectDrawerEnabled ? styles.meetingBooked : '',
            ].join(' ')}
        >
            {contactConnection && conversation && contact ? (
                <ContactDrawerTabbedContent
                    contact={contact}
                    selectedConnection={selectedConnection}
                    conversation={conversation}
                    organizationId={orgId}
                    contactProfile={contactProfile}
                    isOwner={isOwner}
                    isMessagesLoading={isMessagesLoading}
                    tab={tab}
                    onTracking={handleTracking}
                    contactConnection={contactConnection}
                    tabBarStyle={{ margin: 0 }}
                    automatedSteps={automatedSteps}
                    onMessageSent={onMessageSent}
                    communicationStyles={communicationStyles}
                />
            ) : (
                <Skeleton active loading style={{ padding: spacingMD }} />
            )}
        </div>
    );
}
